import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  url: string;
  constructor(
    private http: HttpClient
  ) {
    this.url = environment.api_url;
  }

  getUser(): Observable<any> {
    return this.http.get(this.url + "/start");
  }


  getCenters(): Observable<any> {
    return this.http.post(this.url + "/center", null);

  }

  getPatients(page = 1, search = ""): Observable<any> {
    console.log(search);

    var formData: any = new FormData();
    formData.append("page", page);
    search != "" ? formData.append("search", search) : null;
    console.log(search != "");
    return this.http.post(this.url + "/patient", formData);
  }

  getReceptions(page = 1, search = "", centerId = -1, patientId = -1,
    seenNotOnly = false, filterDate = "", size?, ignoreEmptyNotSeen?, refer = false): Observable<any> {
    var formData: any = new FormData();
    formData.append("page", page);
    formData.append("notSeen", seenNotOnly);

    if (filterDate != "") {
      formData.append("date", filterDate);
    }
    if (size) {
      formData.append("size", size);
    }
    if (ignoreEmptyNotSeen) {
      formData.append("ignoreEmptyNotSeen", ignoreEmptyNotSeen);
    } else {
      formData.append("ignoreEmptyNotSeen", false);
    }
    search != "" ? formData.append("search", search) : null;
    centerId >= 0 ? formData.append("centerId", centerId) : null;
    patientId >= 0 ? formData.append("patientId", patientId) : null;
    if (refer) {
      return this.http.post(this.url + "/reception/refered", formData);
    }
    else {
      return this.http.post(this.url + "/reception", formData);
    }
  }

  getReception(receptionId): Observable<any> {
    var formData: any = new FormData();
    formData.append("id", receptionId);
    return this.http.post(this.url + "/reception/show", formData);
  }

  getImage(imageLink) {
    return this.http.get(imageLink, { responseType: 'blob' })
  }


}
